"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var native_stack_exports = {};
__export(native_stack_exports, {
  NativeStackView: () => NativeStackView,
  createNativeStackNavigator: () => createNativeStackNavigator
});
module.exports = __toCommonJS(native_stack_exports);
var createNativeStackNavigator = function createNativeStackNavigator2() {
  return {
    Navigator: function Navigator() {
      return null;
    },
    Screen: function Screen() {
      return null;
    }
  };
};
var NativeStackView = function NativeStackView2(_props) {
  return null;
};
//# sourceMappingURL=native-stack.js.map
